export default __webpack_public_path__ + "static/media/introOPBg.73266f0e.png";